// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMilestoneFooter_root__yfIb+","submitButton":"PlasmicMilestoneFooter_submitButton__Zszrg","text":"PlasmicMilestoneFooter_text__Njjfh"};